module.exports = __webpack_public_path__ + "img/RTI_Logo.b4d30890.svg";